var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiPaper from '@material-ui/core/Paper';
/**
 * Kareo wrapped component of the Material-UI Paper. The prop API has been limited to props defined in PaperProps.
 *
 * Material-UI Paper: [Docs](https://v4.mui.com/components/Paper/), [API](https://v4.mui.com/api/paper/)
 *
 * @storybook: [Paper](http://design.kareoprod.ent/design-system/?path=/story/components-inputs--paper-example)
 */
var Paper = function (props) {
    return React.createElement(MuiPaper, __assign({}, props));
};
Paper.displayName = 'KareoPaper';
export default Paper;
